import React from "react";
import { GERMAN } from "../actions/language";
import { LanguageContext } from "../context/LanguageContext";
import { Link } from "react-router-dom";
import {
    OFFICE_CONTACT_EMAIL,
    OFFICE_CONTACT_OFFICE_PHONE_NUMBER,
    OFFICE_LOCATION_PLACE,
    OFFICE_LOCATION_STREET
} from "../env";

export default class Footer extends React.Component {
    static contextType = LanguageContext;

    render() {
        const { language } = this.context;
        const de = language === GERMAN;

        return (
            <footer className="tm-footer">
                <div className="tm-footer__inner">
                    <div className="tm-footer__grid">
                        <div className="tm-footer__brand">
                            <img src="/img/T&M-Logo-white.png" alt="Tomé & Martins Dienstleistungen"/>
                            <p>
                                {de
                                    ? 'Büroservice, Hilfestellungen und Verwaltung – persönlich, zweisprachig und zuverlässig. Ihr Partner in Deutschland und Portugal.'
                                    : 'Serviços de escritório, apoio e administração – pessoal, bilingue e fiável. O seu parceiro na Alemanha e em Portugal.'}
                            </p>
                            <span className="tm-footer__since">
                                {de ? 'Seit 2001 an Ihrer Seite.' : 'Ao seu lado desde 2001.'}
                            </span>
                        </div>

                        <div>
                            <h4>{de ? 'Navigation' : 'Navegação'}</h4>
                            <ul>
                                <li><Link to="/">{de ? 'Startseite' : 'Página inicial'}</Link></li>
                                <li><Link to="/about-us/">{de ? 'Über uns' : 'Sobre nós'}</Link></li>
                                <li><Link to="/services/">{de ? 'Leistungen' : 'Serviços'}</Link></li>
                                <li><Link to="/contact/">{de ? 'Kontakt' : 'Contacto'}</Link></li>
                            </ul>
                        </div>

                        <div>
                            <h4>{de ? 'Leistungen' : 'Serviços'}</h4>
                            <ul>
                                <li><Link to="/office-service">{de ? 'Büroservice' : 'Serviço de Escritório'}</Link></li>
                                <li><Link to="/assistance">{de ? 'Hilfestellungen' : 'Apoio'}</Link></li>
                                <li><Link to="/administration">{de ? 'Verwaltung' : 'Administração'}</Link></li>
                            </ul>
                        </div>

                        <div>
                            <h4>{de ? 'Kontakt' : 'Contacto'}</h4>
                            <ul className="tm-footer__contact">
                                <li>
                                    <i className="fas fa-map-marker-alt"/>
                                    <span>{OFFICE_LOCATION_STREET}, {OFFICE_LOCATION_PLACE}</span>
                                </li>
                                <li>
                                    <i className="fas fa-phone"/>
                                    <a href="tel:+4961357044080">{OFFICE_CONTACT_OFFICE_PHONE_NUMBER}</a>
                                </li>
                                <li>
                                    <i className="fas fa-envelope"/>
                                    <a href={'mailto:' + OFFICE_CONTACT_EMAIL}>{OFFICE_CONTACT_EMAIL}</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="tm-footer__bottom">
                        <p>
                            &copy; 2025 Ignilabs —
                            {de ? ' Alle Rechte vorbehalten.' : ' Todos os direitos reservados.'}
                        </p>
                        <div>
                            <Link to="/impressum/" style={{ marginRight: "18px" }}>
                                {de ? 'Impressum' : 'Ficha técnica'}
                            </Link>
                            <Link to="/data-protection" style={{ marginRight: "18px" }}>
                                {de ? 'Datenschutz' : 'Proteção de dados'}
                            </Link>
                            <Link to="/agb">
                                {de ? 'AGB' : 'Termos'}
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js